export default __webpack_public_path__ + "fa704549f65ba528e0bce9fbc7191c4e.png";